import { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Rail } from './Rail'
import { Topbar } from './Topbar'
import { AlertDrawer } from './AlertDrawer'
import { Toasts } from './Toasts'

export function Shell() {
  const [navOpen, setNavOpen] = useState(false)
  const [bellOpen, setBellOpen] = useState(false)
  const { pathname } = useLocation()
  return (
    <div className={`shell${navOpen ? ' nav-open' : ''}`}>
      <Rail onNavigate={() => setNavOpen(false)} />
      <div className="work">
        <Topbar onMenu={() => setNavOpen((v) => !v)} onBell={() => setBellOpen(true)} />
        <main className="view" key={pathname}>
          <Outlet />
        </main>
      </div>
      {navOpen && <div className="scrim" onClick={() => setNavOpen(false)} />}
      <AlertDrawer open={bellOpen} onClose={() => setBellOpen(false)} />
      <Toasts />
    </div>
  )
}
